import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GoKey } from "react-icons/go";
import { MdLogout } from "react-icons/md";
import { RiMenu2Line, RiUser3Line } from 'react-icons/ri';

import logo from '../../assets/images/hire a vendor.png'
import small_logo from '../../assets/images/small-logo-vendor.png'
import _constantUtils, { S3_BASE_URL } from '../../utils/Constant'

const {
    BOOLEAN_FALSE: falseValue,
    NULL,
    LOGOUT
} = _constantUtils;

function Navbar({ buttonRef }) {
    const navigate = useNavigate();

    const [themeMode, setThemeMode] = useState('light');
    const [showConfirmation, setShowConfirmation] = useState(falseValue);
    const [menuOpen, setMenuOpen] = useState(falseValue);
    const dropdownRef = useRef(NULL);
    const dropdownRef1 = useRef(NULL);
    const confirmationRef = useRef(NULL);
    const [profileData, setProfileData] = useState(() => {
        return JSON.parse(localStorage.getItem('vendor_super_data'));
    });

    //* update merchant data when local storage is updated
    useEffect(() => {
        const handleMerchantUpdate = () => {
            const updatedProfile = JSON.parse(localStorage.getItem('vendor_super_data'));
            setProfileData(updatedProfile);
        };

        //* listen to the custom event
        window.addEventListener('profileUpdated', handleMerchantUpdate);

        return () => {
            window.removeEventListener('profileUpdated', handleMerchantUpdate);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !event.composedPath().includes(dropdownRef.current)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    //* theme mode  
    useEffect(() => {
        const handleThemeToggle = () => {
            const newThemeMode = themeMode === 'light' ? 'dark' : 'light';
            setThemeMode(newThemeMode);
            sessionStorage.setItem('themeMode', newThemeMode);
        };

        const storedThemeMode = sessionStorage.getItem('themeMode');

        if (storedThemeMode) {
            setThemeMode(storedThemeMode);
        } else {
            setThemeMode('light');
        }

        const themeToggleElement = document.getElementById('theme-mode');
        if (themeToggleElement) {
            themeToggleElement.addEventListener('click', handleThemeToggle);
        }

        return () => {
            if (themeToggleElement) {
                themeToggleElement.removeEventListener('click', handleThemeToggle);
            }
        };
    }, [themeMode]);

    //* set theme mode
    useEffect(() => {
        document.documentElement.setAttribute('data-bs-theme', themeMode);
    }, [themeMode]);

    //* toggle dropdown
    const toggleDropdown = () => {
        setMenuOpen(!menuOpen);
    };

    //* handle click outside
    const handleClickOutside = (event) => {
        if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
            setMenuOpen(falseValue);
        }
    };

    //* handle click outside
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    //* handle click outside to close confirmation
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
                setShowConfirmation(falseValue);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    //* disable scroll
    useEffect(() => {
        if (showConfirmation) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [showConfirmation]);

    return (
        <>
            {/* //* confirmation */}
            {showConfirmation && (
                <>
                    <div className='modal-backdrop fade show'></div>
                    <div
                        id='user_logout_modal'
                        className='modal fade show'
                        style={{ display: 'block' }}
                    >
                        <div className='modal-dialog'>
                            <div className='modal-content' ref={confirmationRef}>
                                <div className='modal-body'>
                                    <p className='mb-0'>Are you sure to logout from portal ?</p>
                                </div>
                                <div className='modal-footer me-2 border-0'>
                                    <button
                                        type='button'
                                        className='btn btn-danger text-white'
                                        data-dismiss='modal'
                                        onClick={() => setShowConfirmation(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-success text-white'
                                        onClick={() => navigate(LOGOUT)}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <header id='page-topbar'>

                <div className="navbar-header">
                    <div className="d-flex">
                        {/* LOGO */}
                        <div className="navbar-brand-box">
                            <Link to="/dashboard" className="logo logo-dark  mb-0">
                                <span className="logo-sm">
                                    <img
                                        src={small_logo}
                                        alt="logo-sm-dark"
                                        width={50}
                                    />
                                </span>
                                <span className="logo-lg ">
                                    <img
                                        src={logo}
                                        alt="logo-dark"
                                        width={160}
                                    />
                                </span>
                            </Link>
                            <Link
                                to=""
                                className="logo logo-light "
                            >
                                <span className="logo-sm">
                                    <img
                                        src={small_logo}
                                        alt="logo-sm-light"
                                        width={50}
                                    />
                                </span>
                                <span className="logo-lg ">
                                    <img
                                        src={logo}
                                        alt="logo-light"
                                        width={160}
                                    />
                                </span>
                            </Link>
                        </div>

                        <button
                            type="button"
                            className="btn btn-sm px-3 font-size-24 header-item waves-effect mb-1"
                            id="vertical-menu-btn"
                            ref={buttonRef}
                        >
                            <RiMenu2Line />
                        </button>
                        <div className="dropdown dropdown-mega d-none d-xl-block ms-2">
                            <button
                                type="button"
                                className="btn header-item waves-effect"
                                data-bs-toggle="dropdown"
                                aria-haspopup="false"
                                aria-expanded="false"
                            ></button>
                        </div>
                    </div>

                    <div className="d-flex">

                        {/* end notification */}
                        <div className="dropdown d-inline-block user-dropdown" ref={dropdownRef}>
                            <button
                                type="button"
                                className="btn header-item waves-effect"
                                id="page-header-user-dropdown"
                                aria-haspopup="true"
                                aria-expanded={menuOpen ? "true" : "false"}
                                onClick={toggleDropdown}
                            >
                                <img
                                    className="rounded-circle header-profile-user"
                                    src={`${S3_BASE_URL}${profileData.image}`}
                                    alt="Header Avatar"
                                />
                                <span className="d-none d-xl-inline-block ms-1">{profileData.name}</span>
                                <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
                            </button>

                            <div className={`dropdown-menu dropdown-menu-end ${menuOpen ? "show" : ""}`}>
                                <p
                                    onClick={() => {
                                        navigate('/profile/view-profile');
                                        setMenuOpen(false);
                                    }}
                                    className="dropdown-item d-flex align-items-center mb-0 pointer"
                                >
                                    <RiUser3Line className='me-2' /> Profile
                                </p>
                                <p className="dropdown-item d-flex align-items-center mb-0 pointer"
                                    onClick={() => {
                                        navigate('/password/change');
                                        setMenuOpen(false);
                                    }}
                                >
                                    <GoKey className='me-2' /> Change Password
                                </p>
                                <div className="dropdown-divider" />
                                <p className="dropdown-item text-danger d-flex align-items-center mb-0 pointer"
                                    onClick={() => { 
                                        setMenuOpen(false);
                                        setShowConfirmation(true)
                                    }}>
                                    <MdLogout className='me-2' /> Logout
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </header>

        </>
    );
}

export default Navbar;
